import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-timepicker/dist/index.module.css';
import { Close } from '@dtsl/react/dist/components/Close';
import { Text } from '@dtsl/react/dist/components/Text';
const Header = _ref => {
  let {
    headerLabel,
    setIsFloatingPanelVisible,
    onClose
  } = _ref;
  const timePickerHeader = classNames({
    [styles['sib-timepicker-header']]: true
  });
  const onCloseClick = () => {
    setIsFloatingPanelVisible(false);
    onClose(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: timePickerHeader
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    size: "lg",
    fontFamily: "bold",
    tabIndex: 0
  }, headerLabel), /*#__PURE__*/React.createElement(Close, {
    dataTestId: "timepicker-close-buttonId",
    id: "timepicker-close-buttonId",
    ariaLabel: "close button",
    dataTest: "close",
    style: {
      marginLeft: 'auto'
    },
    onClick: onCloseClick,
    tabIndex: 0
  }));
};
Header.propTypes = {
  headerLabel: PropTypes.string,
  setIsFloatingPanelVisible: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default Header;